module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('wxc-cell', {
    attrs: {
      "has-top-border": _vm.hasTopBorder,
      "has-bottom-border": _vm.hasBottomBorder,
      "accessible": true,
      "aria-label": (_vm.title + ",状态为" + (_vm.checked ? '已选中' : '未选中') + "," + (_vm.disabled ? '不可更改' : '点击可切换')),
      "data-evt-wxcCellClicked": ""
    },
    on: {
      "wxcCellClicked": _vm.wxcCellClicked
    }
  }, [_c('p', {
    staticClass: "title-text weex-el weex-text",
    style: ({
      color: _vm.textColor
    }),
    attrs: {
      "slot": "title",
      "weex-type": "text"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('figure', {
    staticClass: "checkbox weex-el weex-image",
    attrs: {
      "slot": "value",
      "src": _vm.checkIcon,
      "data-img-src": _vm.checkIcon,
      "weex-type": "image"
    },
    slot: "value"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-021f0bcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-021f0bcc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-checkbox/index.vue
// module id = 203
// module chunks = 0 1